import assetThumb from "./assetThumb";
import textsGroup from "./textsGroup";

export default `
${textsGroup}
${assetThumb}
`;
